(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("redux"), require("lodash.throttle"), require("scroll-lock"), require("addsearch-js-client"), require("js-cookie"), require("dompurify"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , , , , ], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types"), require("redux"), require("lodash.throttle"), require("scroll-lock"), require("addsearch-js-client"), require("js-cookie"), require("dompurify")) : factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, (__WEBPACK_EXTERNAL_MODULE__5225__, __WEBPACK_EXTERNAL_MODULE__6073__, __WEBPACK_EXTERNAL_MODULE__5293__, __WEBPACK_EXTERNAL_MODULE__7326__, __WEBPACK_EXTERNAL_MODULE__9042__, __WEBPACK_EXTERNAL_MODULE__3916__, __WEBPACK_EXTERNAL_MODULE__4360__, __WEBPACK_EXTERNAL_MODULE__710__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 9787:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export ConnectStateWrapper */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _remote_data_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3511);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



/*
  Connect a react component to a global store.
  This is similar to what react-redux does but uses our global store so
  can share state with other React mount points or anything that uses the
  store.
  - selectors is an object where keys are your prop names and values are your select
  functions that work on the store to retrieve the state you are interested in
  - initial state is set in useEffect so the wrapped component needs to handle it's props set to undefined initially
*/

var ConnectStateWrapper = function ConnectStateWrapper(Component, selectors) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var setStateForKey = function setStateForKey(key) {
    return function (storeState) {
      return setState(function () {
        return _defineProperty({}, key, storeState);
      });
    };
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var store = (0,_remote_data_store__WEBPACK_IMPORTED_MODULE_1__/* .getRemoteDataStore */ .cO)();
    var resolvedState = Object.keys(selectors).reduce(function (acc, key) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, selectors[key](store)));
    }, {}); // Set initial state

    setState(resolvedState); // Create a store subscription for each selector. Depending on your use case, this can be inefficient.
    // When optimising for renders, look for wins with selectors better for your use and using connectState directly.

    Object.keys(selectors).forEach(function (key) {
      (0,_remote_data_store__WEBPACK_IMPORTED_MODULE_1__/* .connectState */ .kZ)(selectors[key], setStateForKey(key));
    });
  }, []);

  var WrappedComponent = function WrappedComponent(props) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Component, _extends({}, props, state));
  };

  return WrappedComponent;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ConnectStateWrapper);

/***/ }),

/***/ 5751:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);




var FeaturedLink = function FeaturedLink(_ref) {
  var url = _ref.url,
      _ref$textSize = _ref.textSize,
      textSize = _ref$textSize === void 0 ? "text-p2" : _ref$textSize,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? "text-cool-black" : _ref$iconColor,
      _ref$flush = _ref.flush,
      flush = _ref$flush === void 0 ? false : _ref$flush,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      _ref$additionalCSS = _ref.additionalCSS,
      additionalCSS = _ref$additionalCSS === void 0 ? "" : _ref$additionalCSS,
      children = _ref.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: url,
    className: "font-sans font-bold block text-gui-default hover:text-gui-hover focus:text-gui-focus focus:outline-gui-focus group ui-".concat(textSize, " ").concat(flush ? "" : "py-8", " ").concat(additionalCSS),
    style: {
      "--featured-link-icon-size": "var(".concat(textSize.replace("text", "--fs"), ")")
    }
  }, reverse ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-gui-link-arrow",
    size: "calc(var(--featured-link-icon-size) * 1.25)",
    color: iconColor,
    additionalCSS: "align-middle mr-8 relative -top-1 -right-4 transition-all group-hover:right-0 transform rotate-180"
  }), children) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-gui-link-arrow",
    size: "calc(var(--featured-link-icon-size) * 1.25)",
    color: iconColor,
    additionalCSS: "align-middle ml-8 relative -top-1 -left-4 transition-all group-hover:left-0"
  })));
};

FeaturedLink.propTypes = {
  url: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node),
  textSize: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  iconColor: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  flush: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  reverse: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  additionalCSS: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FeaturedLink);

/***/ }),

/***/ 2139:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FLASH_DATA_ID": () => (/* binding */ FLASH_DATA_ID)
});

// UNUSED EXPORTS: Flashes, default, reducerFlashes

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react"}
var external_commonjs_react_commonjs2_react_ = __webpack_require__(5225);
var external_commonjs_react_commonjs2_react_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_commonjs2_react_);
// EXTERNAL MODULE: external {"commonjs":"dompurify","commonjs2":"dompurify"}
var external_commonjs_dompurify_commonjs2_dompurify_ = __webpack_require__(710);
var external_commonjs_dompurify_commonjs2_dompurify_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_dompurify_commonjs2_dompurify_);
// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types"}
var external_commonjs_prop_types_commonjs2_prop_types_ = __webpack_require__(6073);
var external_commonjs_prop_types_commonjs2_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_prop_types_commonjs2_prop_types_);
;// CONCATENATED MODULE: ./node_modules/nanoid/non-secure/index.js
let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict'
let customAlphabet = (alphabet, defaultSize = 21) => {
  return (size = defaultSize) => {
    let id = ''
    let i = size
    while (i--) {
      id += alphabet[(Math.random() * alphabet.length) | 0]
    }
    return id
  }
}
let nanoid = (size = 21) => {
  let id = ''
  let i = size
  while (i--) {
    id += urlAlphabet[(Math.random() * 64) | 0]
  }
  return id
}

// EXTERNAL MODULE: ./src/core/remote-data-store.js
var remote_data_store = __webpack_require__(3511);
// EXTERNAL MODULE: ./src/core/ConnectStateWrapper/component.jsx
var component = __webpack_require__(9787);
// EXTERNAL MODULE: ./src/core/Icon/component.jsx
var Icon_component = __webpack_require__(9008);
;// CONCATENATED MODULE: ./src/core/Flash/component.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }








var REDUCER_KEY = "flashes";
var FLASH_DATA_ID = "ui-flashes";
var initialState = {
  items: []
};

var reducerFlashes = _defineProperty({}, REDUCER_KEY, function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case "flash/push":
      {
        var flashes = Array.isArray(action.payload) ? action.payload : [action.payload];
        return {
          items: [].concat(_toConsumableArray(state.items), _toConsumableArray(flashes))
        };
      }

    default:
      return state;
  }
});

var selectFlashes = function selectFlashes(store) {
  return store.getState()[REDUCER_KEY];
};

var FlashT = {
  type: external_commonjs_prop_types_commonjs2_prop_types_default().oneOf(["error", "success", "notice", "info", "alert"]),
  content: (external_commonjs_prop_types_commonjs2_prop_types_default()).string
};
var FLASH_BG_COLOR = {
  error: "bg-gui-error",
  success: "bg-zingy-green",
  notice: "bg-electric-cyan",
  info: "bg-electric-cyan",
  alert: "bg-active-orange"
};
var FLASH_TEXT_COLOR = {
  error: "text-white",
  success: "text-cool-black",
  notice: "text-cool-black",
  info: "text-cool-black",
  alert: "text-white"
};
var AUTO_HIDE = ["success", "info", "notice"];
var AUTO_HIDE_TIME = 8000;

var useAutoHide = function useAutoHide(type, closeFlash) {
  var timeoutId = (0,external_commonjs_react_commonjs2_react_.useRef)(null);
  (0,external_commonjs_react_commonjs2_react_.useEffect)(function () {
    if (AUTO_HIDE.includes(type)) {
      timeoutId.current = setTimeout(function () {
        closeFlash();
      }, AUTO_HIDE_TIME);
    }

    return function () {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  }, []);
};

var Flash = function Flash(_ref) {
  var id = _ref.id,
      type = _ref.type,
      content = _ref.content,
      removeFlash = _ref.removeFlash;
  var ref = (0,external_commonjs_react_commonjs2_react_.useRef)(null);

  var _useState = (0,external_commonjs_react_commonjs2_react_.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  var _useState3 = (0,external_commonjs_react_commonjs2_react_.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      flashHeight = _useState4[0],
      setFlashHeight = _useState4[1];

  var _useState5 = (0,external_commonjs_react_commonjs2_react_.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      triggerEntryAnimation = _useState6[0],
      setTriggerEntryAnimation = _useState6[1];

  var closeFlash = function closeFlash() {
    if (ref.current) {
      setFlashHeight(ref.current.getBoundingClientRect().height);
    }

    setClosed(true);
    setTimeout(function () {
      removeFlash(id);
    }, 100);
  };

  (0,external_commonjs_react_commonjs2_react_.useEffect)(function () {
    return setTriggerEntryAnimation(true);
  }, []);
  useAutoHide(type, closeFlash);
  var animateEntry = triggerEntryAnimation && !closed;
  var style;

  if (flashHeight && !closed) {
    style = {
      height: "".concat(flashHeight, "px")
    };
  } else if (closed) {
    style = {
      height: 0,
      marginTop: 0,
      zIndex: -1
    };
  } else {
    style = {};
  }

  var safeContent = external_commonjs_dompurify_commonjs2_dompurify_default().sanitize(content, {
    ALLOWED_TAGS: ["a"],
    ALLOWED_ATTR: ["href", "data-method", "rel"]
  });
  var withIcons = {
    notice: "icon-gui-ably-badge",
    success: "icon-gui-tick",
    error: "icon-gui-warning",
    alert: "icon-gui-warning"
  };
  var iconColor = {
    notice: "text-cool-black",
    success: "text-cool-black",
    error: "text-white",
    alert: "text-white"
  };
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-flash-message ui-grid-px ".concat(animateEntry ? "ui-flash-message-enter" : ""),
    style: style,
    ref: ref,
    "data-id": "ui-flash"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "".concat(FLASH_BG_COLOR[type], " p-32 flex align-center rounded shadow-container-subtle")
  }, withIcons[type] && /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Icon_component["default"], {
    name: withIcons[type],
    color: iconColor[type],
    size: "1.5rem",
    additionalCSS: "mr-16 self-baseline"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-text-p1 mr-16 ".concat(FLASH_TEXT_COLOR[type]),
    dangerouslySetInnerHTML: {
      __html: safeContent
    }
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("button", {
    type: "button",
    className: "p-0 ml-auto self-start focus:outline-none",
    onClick: closeFlash
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Icon_component["default"], {
    name: "icon-gui-close",
    color: iconColor[type],
    size: "1.5rem",
    additionalCSS: "transition-colors"
  }))));
};

Flash.propTypes = _objectSpread({}, FlashT);

var Flashes = function Flashes(_ref2) {
  var flashes = _ref2.flashes;

  var _useState7 = (0,external_commonjs_react_commonjs2_react_.useState)([]),
      _useState8 = _slicedToArray(_useState7, 2),
      flashesWithIds = _useState8[0],
      setFlashesWithIds = _useState8[1];

  var removeFlash = function removeFlash(flashId) {
    return setFlashesWithIds(function (items) {
      return items.filter(function (item) {
        return item.id !== flashId;
      });
    });
  };

  (0,external_commonjs_react_commonjs2_react_.useEffect)(function () {
    setFlashesWithIds(function (state) {
      return [].concat(_toConsumableArray(state), _toConsumableArray(((flashes === null || flashes === void 0 ? void 0 : flashes.items) || []).map(function (flash) {
        return _objectSpread(_objectSpread({}, flash), {}, {
          id: nanoid(),
          removed: false
        });
      })));
    });
  }, [flashes]);
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-flash",
    "data-id": FLASH_DATA_ID
  }, flashesWithIds.filter(function (item) {
    return !item.removed;
  }).map(function (flash) {
    return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Flash, _extends({
      removeFlash: removeFlash,
      key: flash.id
    }, flash));
  }));
};

Flashes.propTypes = {
  flashes: external_commonjs_prop_types_commonjs2_prop_types_default().shape({
    items: external_commonjs_prop_types_commonjs2_prop_types_default().arrayOf(external_commonjs_prop_types_commonjs2_prop_types_default().shape(FlashT))
  })
};

var BackendFlashes = function BackendFlashes(_ref3) {
  var flashes = _ref3.flashes;
  (0,external_commonjs_react_commonjs2_react_.useEffect)(function () {
    var transformedFlashes = flashes.map(function (flash) {
      var _flash = _slicedToArray(flash, 2),
          type = _flash[0],
          content = _flash[1];

      return {
        type: type,
        content: content
      };
    }) || [];

    if (transformedFlashes.length > 0) {
      var store = (0,remote_data_store/* getRemoteDataStore */.cO)();
      store.dispatch({
        type: "flash/push",
        payload: transformedFlashes
      });
    }
  }, []);
  var WrappedFlashes = (0,component["default"])(Flashes, {
    flashes: selectFlashes
  });
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(WrappedFlashes, null);
};

BackendFlashes.propTypes = {
  flashes: external_commonjs_prop_types_commonjs2_prop_types_default().arrayOf(external_commonjs_prop_types_commonjs2_prop_types_default().arrayOf((external_commonjs_prop_types_commonjs2_prop_types_default()).string))
};

/* harmony default export */ const Flash_component = ((/* unused pure expression or super */ null && (BackendFlashes)));

/***/ }),

/***/ 9008:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded = ["name", "size", "color", "additionalCSS"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Icon = function Icon(_ref) {
  var name = _ref.name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "0.75rem" : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "" : _ref$color,
      _ref$additionalCSS = _ref.additionalCSS,
      additionalCSS = _ref$additionalCSS === void 0 ? "" : _ref$additionalCSS,
      additionalAttributes = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", _extends({
    className: "".concat(color, " ").concat(additionalCSS),
    style: {
      width: size,
      height: size
    }
  }, additionalAttributes), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("use", {
    xlinkHref: "#sprite-".concat(name)
  }));
};

Icon.propTypes = {
  name: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string.isRequired),
  size: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  additionalCSS: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Icon);

/***/ }),

/***/ 3774:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




var Logo = function Logo(_ref) {
  var dataId = _ref.dataId,
      logoUrl = _ref.logoUrl,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? "/" : _ref$href,
      additionalImgAttrs = _ref.additionalImgAttrs,
      additionalLinkAttrs = _ref.additionalLinkAttrs;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", _extends({
    href: href,
    "data-id": dataId,
    className: "block",
    style: {
      height: "2.125rem"
    }
  }, additionalLinkAttrs), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", _extends({
    src: logoUrl,
    width: "108px",
    alt: "Ably logo"
  }, additionalImgAttrs)));
};

Logo.propTypes = {
  dataId: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  href: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  logoUrl: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  additionalImgAttrs: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
  additionalLinkAttrs: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().memo(Logo));

/***/ }),

/***/ 2725:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _FeaturedLink_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5751);




var MeganavBlogPostsList = function MeganavBlogPostsList(_ref) {
  var recentBlogPosts = _ref.recentBlogPosts,
      absUrl = _ref.absUrl;
  return recentBlogPosts ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-span-full md:col-span-4 pt-8 pb-24 md:py-24 lg:py-32 px-24 sm:px-32 md:px-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "ui-meganav-overline",
    id: "meganav-company-panel-list-blog"
  }, "Blog"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "mb-8",
    "aria-labelledby": "meganav-company-panel-list-blog"
  }, recentBlogPosts.map(function (post) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
      key: post.link
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
      href: post.link,
      className: "ui-meganav-media group"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "ui-meganav-media-heading"
    }, post.title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "ui-meganav-media-copy"
    }, post.pubDate)));
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_FeaturedLink_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    url: absUrl("/blog"),
    textSize: "text-p3"
  }, "More from our Blog")) : null;
};

MeganavBlogPostsList.propTypes = {
  recentBlogPosts: prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape({
    link: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    pubDate: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
  })),
  absUrl: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MeganavBlogPostsList);

/***/ }),

/***/ 1505:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ MeganavContentCompany_component)
});

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react"}
var external_commonjs_react_commonjs2_react_ = __webpack_require__(5225);
var external_commonjs_react_commonjs2_react_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_commonjs2_react_);
// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types"}
var external_commonjs_prop_types_commonjs2_prop_types_ = __webpack_require__(6073);
var external_commonjs_prop_types_commonjs2_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_prop_types_commonjs2_prop_types_);
// EXTERNAL MODULE: ./src/core/MeganavBlogPostsList/component.jsx
var component = __webpack_require__(2725);
// EXTERNAL MODULE: ./src/core/ConnectStateWrapper/component.jsx
var ConnectStateWrapper_component = __webpack_require__(9787);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(4687);
;// CONCATENATED MODULE: ./src/core/remote-blogs-posts.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



var fetchBlogPosts = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(store, blogUrl) {
    var res, payload;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (blogUrl) {
              _context.next = 4;
              break;
            }

            console.log("Skipping fetching blog posts, invalid blogUrl: \"".concat(blogUrl, "\""));
            return _context.abrupt("return");

          case 4:
            _context.next = 6;
            return fetch(blogUrl);

          case 6:
            res = _context.sent;

            if (!isJsonResponse(res.headers.get("content-type"))) {
              _context.next = 14;
              break;
            }

            _context.next = 10;
            return res.json();

          case 10:
            payload = _context.sent;
            store.dispatch({
              type: "blog/loaded",
              payload: payload
            });
            _context.next = 15;
            break;

          case 14:
            throw new Error("Blog posts url is not serving json");

          case 15:
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](0);
            console.warn("Could not fetch blog posts due to error:", _context.t0);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 17]]);
  }));

  return function fetchBlogPosts(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()));

var initialState = {
  recent: null
};
var REDUCER_KEY = "blogPosts";

var reducerBlogPosts = _defineProperty({}, REDUCER_KEY, function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case "blog/loaded":
      return _objectSpread(_objectSpread({}, state), {}, {
        recent: action.payload
      });

    default:
      return state;
  }
});

var selectRecentBlogPosts = function selectRecentBlogPosts(store) {
  var _store$getState$REDUC;

  return (_store$getState$REDUC = store.getState()[REDUCER_KEY]) === null || _store$getState$REDUC === void 0 ? void 0 : _store$getState$REDUC.recent;
};


// EXTERNAL MODULE: ./src/core/Icon/component.jsx
var Icon_component = __webpack_require__(9008);
;// CONCATENATED MODULE: ./src/core/MeganavContentCompany/component.jsx







var MeganavContentCompany = function MeganavContentCompany(_ref) {
  var paths = _ref.paths,
      absUrl = _ref.absUrl;
  var BlogPostsList = (0,ConnectStateWrapper_component["default"])(component["default"], {
    recentBlogPosts: selectRecentBlogPosts
  });
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex max-w-screen-xl mx-auto"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-meganav-content-spacer"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("section", {
    className: "grid grid-cols-12 ui-grid-gap-x w-full"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "col-span-full md:col-span-4 pt-24 md:py-24 lg:py-32 px-24 sm:px-32 md:pl-0 md:pr-24"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("h3", {
    className: "ui-meganav-overline",
    id: "meganav-company-panel-list-why-companies"
  }, "Why companies choose Ably"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("ul", {
    "aria-labelledby": "meganav-company-panel-list-why-companies"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/customers"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Icon_component["default"], {
    name: "icon-display-customers-col",
    size: "2.5rem"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Customers"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Ably supports customers across multiple industries.")))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/case-studies"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Icon_component["default"], {
    name: "icon-display-case-studies-col",
    size: "2.5rem"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Case studies"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Discover how customers are benefiting from Ably.")))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/compare"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Icon_component["default"], {
    name: "icon-display-compare-tech-col",
    size: "2.5rem"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Compare our tech"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Choose the right realtime service.")))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/aws"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("img", {
    src: paths.awsLogo,
    alt: "AWS logo"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Partners"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Ably collaborates and integrates with AWS.")))))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "col-span-full md:col-span-4 pb-8 md:py-24 lg:py-32 px-24 sm:px-32 md:px-0"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("ul", {
    className: "md:mt-40",
    "aria-labelledby": "meganav-company-panel-list-why-companies"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/resources"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Icon_component["default"], {
    name: "icon-display-resources-col",
    size: "2.5rem"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Resources"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Learn more about realtime with our handy resources.")))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/about"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Icon_component["default"], {
    name: "icon-display-about-ably-col",
    size: "2.5rem"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "About Ably"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Find out more about Ably\u2019s mission.")))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/careers"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Icon_component["default"], {
    name: "icon-display-careers-col",
    size: "2.5rem"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Careers"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Discover our open roles and core Ably values.")))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/events"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Icon_component["default"], {
    name: "icon-display-events-col",
    size: "2.5rem"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Events"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Join Ably at upcoming events.")))))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(BlogPostsList, {
    absUrl: absUrl
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-meganav-content-spacer"
  }));
};

MeganavContentCompany.propTypes = {
  absUrl: (external_commonjs_prop_types_commonjs2_prop_types_default()).func,
  paths: external_commonjs_prop_types_commonjs2_prop_types_default().shape({
    awsLogo: (external_commonjs_prop_types_commonjs2_prop_types_default()).string
  })
};
/* harmony default export */ const MeganavContentCompany_component = (MeganavContentCompany);

/***/ }),

/***/ 2619:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);




var MeganavContentDevelopers = function MeganavContentDevelopers(_ref) {
  var absUrl = _ref.absUrl;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex max-w-screen-xl mx-auto"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "ui-meganav-content-spacer"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("section", {
    className: "grid grid-cols-12 ui-grid-gap-x w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-span-full md:col-span-4 pt-24 md:py-24 lg:py-32 px-24 sm:px-32 md:pl-0 md:pr-24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "ui-meganav-overline uppercase",
    id: "meganav-developers-panel-explore"
  }, "Explore"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    "aria-labelledby": "meganav-developers-panel-explore"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/docs"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-display-docs-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Documentation"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Technical guides to help you build with Ably.")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/docs/quick-start-guide"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-display-quickstart-guides-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Quickstart guides"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Documentation to help you get started quickly.")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/integrations"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-display-integrations-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Integrations"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Find out more about Ably integrations. ")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/examples"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-display-examples-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Live examples"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Discover our features and their use cases.")))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-span-full md:col-span-4 pb-8 md:py-24 lg:py-32 px-24 sm:px-32 md:px-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "md:mt-40",
    "aria-labelledby": "meganav-developers-panel-explore"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/docs/sdks"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-display-sdks-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "SDKs"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Download an SDK to help you build realtime apps faster.")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/tutorials"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-display-tutorials-demos-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Tutorials & Demos"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Get stuck in with our hands-on resources.")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/reference-guide-chat"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-display-chat-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Chat apps reference guide"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Learn how to build chat apps with Ably.")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/reference-guide-multiplayer"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-multi-user-spaces-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Multiplayer reference guide"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Learn how to build collaborative features with Ably.")))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-span-full md:col-span-4 pt-8 pb-24 md:py-24 lg:py-32 px-24 sm:px-32 md:px-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "ui-meganav-overline uppercase",
    id: "meganav-developers-panel-quick-links"
  }, "Quick links"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    "aria-labelledby": "meganav-developers-panel-quick-links"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: "https://discord.gg/jwBPhEZ9g5",
    className: "group ui-meganav-media py-12"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Discord"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: "https://github.com/ably",
    className: "group ui-meganav-media py-12"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "GitHub"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: "https://changelog.ably.com/",
    className: "group ui-meganav-media py-12"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Changelog"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: "https://status.ably.com/",
    className: "group ui-meganav-media py-12"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Status", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("iframe", {
    title: "Ably status",
    src: "https://status.ably.com/embed/icon",
    allowtransparency: "true",
    frameBorder: "0",
    scrolling: "no",
    className: "w-24 h-24 ml-4 border-none pointer-events-none align-middle"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/support"),
    className: "group ui-meganav-media py-12"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Support & FAQs")))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "ui-meganav-content-spacer"
  }));
};

MeganavContentDevelopers.propTypes = {
  absUrl: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MeganavContentDevelopers);

/***/ }),

/***/ 8254:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _FeaturedLink_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5751);




var MeganavContentProducts = function MeganavContentProducts(_ref) {
  var paths = _ref.paths,
      absUrl = _ref.absUrl;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex max-w-screen-xl mx-auto"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "ui-meganav-content-spacer bg-extra-light-grey"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("section", {
    className: "grid grid-cols-12 ui-grid-gap-x w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-span-full md:col-span-4 py-24 lg:py-32 px-24 sm:px-32 md:pl-0 md:pr-24 bg-extra-light-grey"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex mb-20"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: paths.ablyStack,
    alt: "Ably homepage"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "ui-meganav-overline ml-24"
  }, "The Ably Platform")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-text-p2 font-bold mb-24",
    style: {
      maxWidth: "330px"
    }
  }, "Easily power any realtime experience in your application. No complex infrastructure to manage or provision. Just a simple API that handles everything realtime, and lets you focus on your code."), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_FeaturedLink_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    url: absUrl("/platform"),
    textSize: "text-p2"
  }, "Explore how it works")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-span-full md:col-span-4 pt-24 pb-8 md:py-24 lg:py-32 px-24 sm:px-32 md:px-0 bg-white"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "ui-meganav-overline",
    id: "meganav-products-panel-list-examples"
  }, "Products"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "mb-16",
    "aria-labelledby": "meganav-products-panel-list-examples"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/channels"),
    className: "group ui-meganav-media"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Pub/Sub Channels"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Build infinitely scalable realtime applications."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/spaces"),
    className: "group ui-meganav-media"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Spaces (Beta)"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Create multi-user collaborative environments."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/livesync"),
    className: "group ui-meganav-media"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "LiveSync (Pre release)"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Keep clients in sync with any relational database."))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-span-full md:col-span-4 pt-8 pb-24 md:py-24 lg:py-32 px-24 sm:px-32 md:px-0 bg-white"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "ui-meganav-overline",
    id: "meganav-products-panel-list-our-technology"
  }, "Technology"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "mb-16",
    "aria-labelledby": "meganav-products-panel-list-our-technology"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/four-pillars-of-dependability#performance"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Predictable performance"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "A low-latency and high-throughput global network."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/four-pillars-of-dependability#integrity"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Guaranteed ordering & delivery"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Data is delivered - in order - even after disconnections."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/four-pillars-of-dependability#reliability"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Fault tolerant infrastructure"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Redundancy is built in at global and regional levels."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/four-pillars-of-dependability#availability"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "High scalability & availability"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Built for scale with legitimate 99.999% uptime SLAs."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/network"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Global edge network"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "An edge network of 15 core routing datacenters and 205+ PoPs.")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_FeaturedLink_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    url: absUrl("/four-pillars-of-dependability"),
    textSize: "text-p3"
  }, "Explore Four Pillars of Dependability"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "ui-meganav-content-spacer"
  }));
};

MeganavContentProducts.propTypes = {
  paths: prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape({
    ablyStack: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    iconSprites: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
  }),
  absUrl: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MeganavContentProducts);

/***/ }),

/***/ 1118:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);




var MeganavContentUseCases = function MeganavContentUseCases(_ref) {
  var absUrl = _ref.absUrl;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex max-w-screen-xl mx-auto"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "ui-meganav-content-spacer bg-extra-light-grey"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("section", {
    className: "grid grid-cols-12 ui-grid-gap-x w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-span-full md:col-span-4 py-24 lg:py-32 px-24 sm:px-32 md:pl-0 md:pr-24 bg-extra-light-grey"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "ui-meganav-overline",
    id: "meganav-use-cases-panel-use-cases"
  }, "Solutions"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    "aria-labelledby": "meganav-use-cases-panel-industry-use-cases"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/chat"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-display-chat-stack-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Live Chat"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Deliver highly reliable chat experiences at scale.")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/multiplayer-collaboration"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-multi-user-spaces-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Multiplayer Collaboration"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Bring collaborative multiplayer experiences to your users.")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/data-broadcast"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-display-data-broadcast-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Data Broadcast"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Broadcast realtime event data to millions of devices around the globe.")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/data-synchronization"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-display-data-synchronization-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Data Synchronization"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Keep your frontend and backend in realtime sync, at global scale.")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/push-notifications"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-display-push-notifications-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Notifications"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Deliver cross-platform push notifications with a simple unified API.")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/asset-tracking"),
    className: "ui-meganav-media-with-image group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-display-asset-tracking-col",
    size: "2.5rem"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex flex-col justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Asset Tracking (Beta)"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Track assets in realtime with a solution optimised for last mile logistics.")))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-span-full md:col-span-4 pt-24 pb-0 md:py-24 lg:py-32 px-24 sm:px-32 md:px-0 bg-white"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "ui-meganav-overline",
    id: "meganav-use-cases-panel-industry"
  }, "Industry"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    "aria-labelledby": "meganav-use-cases-panel-industry"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/edtech"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "EdTech"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Deliver interactive learning experiences."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/fintech"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "FinTech"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Deliver personalised financial data in realtime."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/automotive-logistics-and-mobility"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Automotive, Logistics, & Mobility"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Power diagnostics, order tracking and more."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/b2b-platforms"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "B2B Platforms"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Empower your customers with realtime solutions."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/healthcare"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Healthcare (HIPAA)"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Provide trustworthy, HIPAA-compliant realtime apps."))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-span-full md:col-span-4 pt-0 pb-24 md:py-24 lg:py-32 px-24 sm:px-32 md:px-0 bg-white"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    "aria-labelledby": "meganav-use-cases-panel-solutions",
    className: "mt-0 md:mt-40"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/ecommerce-and-retail"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "eCommerce & Retail"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Enrich customer experiences with realtime updates."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/sports-and-media"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Sports, Media & Audience Engagement"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Deliver engaging global realtime experiences."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/gaming"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "Gaming"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Power ultra fast and reliable gaming experiences."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/solutions/iot-and-connected-devices"),
    className: "ui-meganav-media group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-heading"
  }, "IoT & Connected Devices"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-media-copy"
  }, "Monitor and control global IoT deployments in realtime.")))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "ui-meganav-content-spacer"
  }));
};

MeganavContentUseCases.propTypes = {
  absUrl: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MeganavContentUseCases);

/***/ }),

/***/ 140:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);




var MeganavControl = function MeganavControl(_ref) {
  var ariaControls = _ref.ariaControls,
      ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      theme = _ref.theme,
      additionalCSS = _ref.additionalCSS;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    type: "button",
    "data-id": "meganav-control",
    className: "ui-meganav-link h-64 flex items-center group ".concat(additionalCSS, " ").concat(theme.textColor),
    "aria-expanded": "false",
    "aria-controls": ariaControls,
    "aria-label": "Show ".concat(ariaLabel, " panel")
  }, children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-gui-disclosure-arrow",
    color: "text-cool-black",
    size: "1.5rem",
    additionalCSS: "transform rotate-90 group-hover:text-gui-hover group-focus:text-gui-focus"
  }));
};

MeganavControl.propTypes = {
  ariaControls: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  ariaLabel: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node),
  theme: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
  additionalCSS: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MeganavControl);

/***/ }),

/***/ 8746:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);




var MeganavControlMobileDropdown = function MeganavControlMobileDropdown(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    type: "button",
    className: "block ml-24 mr-0 px-0 py-16 hover:text-gui-hover focus:text-gui-focus focus:outline-none",
    "data-id": "meganav-control-mobile-dropdown",
    "aria-expanded": "false",
    "aria-controls": "meganav-mobile-dropdown"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-gui-burger-menu",
    size: "1.5rem",
    color: theme.mobileMenuColor,
    additionalCSS: "transition-colors",
    "data-id": "meganav-control-mobile-dropdown-menu"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-gui-close",
    size: "1.5rem",
    color: theme.mobileMenuColor,
    additionalCSS: "transition-colors hidden",
    "data-id": "meganav-control-mobile-dropdown-close"
  }));
};

MeganavControlMobileDropdown.propTypes = {
  theme: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MeganavControlMobileDropdown);

/***/ }),

/***/ 5598:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);




var MeganavControlMobilePanelClose = function MeganavControlMobilePanelClose(_ref) {
  var ariaControls = _ref.ariaControls,
      _ref$displayHr = _ref.displayHr,
      displayHr = _ref$displayHr === void 0 ? true : _ref$displayHr;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "mx-24 md:mx-32"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    type: "button",
    className: "ui-meganav-mobile-link text-gui-default mb-16",
    "data-id": "meganav-control-mobile-panel-close",
    "aria-expanded": "false",
    "aria-controls": ariaControls,
    "aria-label": "Hide panel"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-gui-disclosure-arrow",
    color: "text-cool-black",
    size: "1.5rem",
    additionalCSS: "relative -top-1 transform rotate-180"
  }), "Back"), displayHr ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("hr", {
    className: "ui-meganav-hr"
  }) : null);
};

MeganavControlMobilePanelClose.propTypes = {
  ariaControls: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  displayHr: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MeganavControlMobilePanelClose);

/***/ }),

/***/ 7806:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);




var MeganavControlMobilePanelOpen = function MeganavControlMobilePanelOpen(_ref) {
  var ariaControls = _ref.ariaControls,
      children = _ref.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    type: "button",
    className: "ui-meganav-mobile-link",
    "data-id": "meganav-control-mobile-panel-open",
    "aria-expanded": "false",
    "aria-controls": ariaControls,
    "aria-label": "Show ".concat(children)
  }, children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-gui-disclosure-arrow",
    color: "text-cool-black",
    size: "1.5rem",
    additionalCSS: "relative -top-1 ml-auto float-right"
  }));
};

MeganavControlMobilePanelOpen.propTypes = {
  ariaControls: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MeganavControlMobilePanelOpen);

/***/ }),

/***/ 3893:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Meganav_component_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3166);
/* harmony import */ var _MeganavControl_component_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(140);





var MeganavDesktopItems = function MeganavDesktopItems(_ref) {
  var panels = _ref.panels,
      paths = _ref.paths,
      theme = _ref.theme,
      absUrl = _ref.absUrl;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "hidden md:flex",
    "data-id": "meganav-items-desktop"
  }, _Meganav_component_json__WEBPACK_IMPORTED_MODULE_2__/* .panels.map */ .h.map(function (panel) {
    var PanelComponent = panels[panel.component];
    var bgCSS = ["products-panel", "use-cases-panel"].includes(panel.id) ? "ui-meganav-panel-split-bg" : "";
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
      className: "ui-meganav-item",
      key: panel.id
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_MeganavControl_component_jsx__WEBPACK_IMPORTED_MODULE_3__["default"], {
      theme: theme,
      ariaControls: panel.id,
      ariaLabel: panel.label
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "hidden lg:inline"
    }, panel.label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "lg:hidden"
    }, panel.shortLabel)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "ui-meganav-panel invisible ".concat(bgCSS),
      id: panel.id,
      "data-id": "meganav-panel"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(PanelComponent, {
      paths: paths,
      absUrl: absUrl
    })));
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    className: "ui-meganav-item"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/pricing"),
    "data-id": "meganav-link",
    className: "ui-meganav-link h-64 items-center flex ".concat(theme.textColor)
  }, "Pricing")));
};

MeganavDesktopItems.propTypes = {
  panels: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
  paths: prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape({
    logo: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    iconSprites: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    ablyStack: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    blogThumb1: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    blogThumb2: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    blogThumb3: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
  }),
  theme: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
  absUrl: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().memo(MeganavDesktopItems));

/***/ }),

/***/ 2016:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _SignOutLink_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1866);
/* harmony import */ var _MeganavSearchSuggestions_component_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8926);
/* harmony import */ var _Icon_component_jsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var _Meganav_component_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3166);
/* harmony import */ var _MeganavControlMobileDropdown_component_jsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8746);
/* harmony import */ var _MeganavControlMobilePanelClose_component_jsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5598);
/* harmony import */ var _MeganavControlMobilePanelOpen_component_jsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7806);
/* harmony import */ var _MeganavSearchAutocomplete_component_jsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3833);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }












var MeganavItemsMobile = function MeganavItemsMobile(_ref) {
  var panels = _ref.panels,
      paths = _ref.paths,
      sessionState = _ref.sessionState,
      theme = _ref.theme,
      loginLink = _ref.loginLink,
      absUrl = _ref.absUrl;
  var classNames = "ui-meganav-link ".concat(theme.textColor);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "flex md:hidden",
    "data-id": "meganav-items-mobile"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, sessionState.signedIn && sessionState.logOut ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_SignOutLink_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], _extends({
    absUrl: absUrl
  }, sessionState.logOut), function (_ref2) {
    var text = _ref2.text,
        href = _ref2.href,
        onClick = _ref2.onClick;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
      onClick: onClick,
      href: absUrl(href),
      className: classNames,
      "data-id": "meganav-link"
    }, text);
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl(loginLink),
    className: classNames,
    "data-id": "meganav-link"
  }, "Login")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    className: "ui-meganav-item"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_MeganavControlMobileDropdown_component_jsx__WEBPACK_IMPORTED_MODULE_6__["default"], {
    theme: theme
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "ui-meganav-mobile-dropdown invisible",
    id: "meganav-mobile-dropdown",
    "data-id": "meganav-mobile-dropdown"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "pt-24 pb-16 ui-grid-px bg-white"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("form", {
    className: "mb-16",
    action: absUrl("/search"),
    method: "get"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "relative w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_4__["default"], {
    name: "icon-gui-search",
    color: "text-cool-black",
    size: "1.5rem",
    additionalCSS: "absolute top-12 left-16 hover:text-gui-hover"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    type: "button",
    className: "absolute top-12 right-16 p-0 focus:outline-gui-focus m-0 md:hidden invisible",
    "data-id": "meganav-search-input-clear"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_4__["default"], {
    name: "icon-gui-cross-circled-fill",
    color: "text-dark-grey",
    size: "1.5rem",
    additionalCSS: ""
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    type: "search",
    name: "q",
    className: "ui-input px-48 h-48",
    style: {
      maxWidth: "none"
    },
    placeholder: "Search",
    autoComplete: "off",
    "data-id": "meganav-mobile-search-input"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_MeganavSearchAutocomplete_component_jsx__WEBPACK_IMPORTED_MODULE_9__["default"], null))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "max-h-0 overflow-hidden transition-all",
    "data-id": "meganav-mobile-search-suggestions"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_MeganavSearchSuggestions_component_jsx__WEBPACK_IMPORTED_MODULE_3__["default"], {
    absUrl: absUrl,
    displaySupportLink: false
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "mb-16",
    "data-id": "meganav-mobile-panel-controls"
  }, _Meganav_component_json__WEBPACK_IMPORTED_MODULE_5__/* .panels.map */ .h.map(function (panel) {
    var PanelComponent = panels[panel.component];
    var displayHr = ["company-panel", "developers-panel"].includes(panel.id);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
      className: "ui-meganav-mobile-item",
      key: "".concat(panel.id, "-mobile")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_MeganavControlMobilePanelOpen_component_jsx__WEBPACK_IMPORTED_MODULE_8__["default"], {
      ariaControls: "".concat(panel.id, "-mobile")
    }, panel.label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "ui-meganav-panel-mobile hidden",
      id: "".concat(panel.id, "-mobile"),
      "data-scroll-lock-scrollable": true
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_MeganavControlMobilePanelClose_component_jsx__WEBPACK_IMPORTED_MODULE_7__["default"], {
      ariaControls: "".concat(panel.id, "-mobile"),
      displayHr: displayHr
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(PanelComponent, {
      paths: paths,
      absUrl: absUrl
    })));
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/pricing"),
    className: "ui-meganav-mobile-link"
  }, "Pricing"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("hr", {
    className: "ui-meganav-hr mb-20"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex justify-between items-center mb-16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/contact"),
    className: "text-menu2 font-medium block ml-0 mr-8 lg:mx-12 p-0 hover:text-gui-hover focus:text-gui-focus focus:outline-none"
  }, "Contact us"), sessionState.signedIn && sessionState.account ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl(sessionState.account.links.dashboard.href),
    className: "ui-btn-secondary"
  }, "Dashboard") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/sign-up"),
    className: "ui-btn"
  }, "Sign up free"))))));
};

MeganavItemsMobile.propTypes = {
  panels: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
  paths: prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape({
    iconSprites: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
  }),
  sessionState: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
  theme: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
  loginLink: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  absUrl: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().memo(MeganavItemsMobile, function (oldState, newState) {
  var pathsOld = oldState.pathsOld,
      themeOld = oldState.themeOld;
  var pathsNew = newState.pathsNew,
      themeNew = newState.themeNew;

  if (pathsOld === pathsNew && themeOld === themeNew && Object.keys(newState.sessionState || {}).length === 0) {
    return true;
  } else {
    return false;
  }
}));

/***/ }),

/***/ 9508:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _MeganavControl_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(140);
/* harmony import */ var _SignOutLink_component_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1866);
/* harmony import */ var _MeganavSearch_component_jsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }







var truncate = function truncate(string, length) {
  return string !== null && string !== void 0 && string.length && string.length > length ? "".concat(string.slice(0, length - 1), "\u2026") : string;
};

var MeganavItemsSignedIn = function MeganavItemsSignedIn(_ref) {
  var sessionState = _ref.sessionState,
      theme = _ref.theme,
      absUrl = _ref.absUrl;
  var links = sessionState.account ? Object.keys(sessionState.account.links).map(function (key) {
    return sessionState.account.links[key];
  }) : [];
  var accountName = truncate(sessionState.accountName, 20);
  var preferredEmail = truncate(sessionState.preferredEmail, 20);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "hidden md:flex items-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    className: "ui-meganav-item relative"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_MeganavControl_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    ariaControls: "account-panel",
    ariaLabel: "Account",
    theme: theme,
    additionalCSS: "mr-0"
  }, accountName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "ui-meganav-panel-account invisible",
    id: "account-panel",
    "data-id": "meganav-panel"
  }, sessionState.account && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-overline mt-16 mx-16"
  }, "Your account"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "mb-16 mx-16"
  }, links.map(function (item) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
      key: item.href
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
      className: "ui-meganav-account-link",
      href: absUrl(item.href)
    }, item.text));
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-meganav-overline mx-16"
  }, preferredEmail), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "mb-8 mx-16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl(sessionState.mySettings.href),
    className: "ui-meganav-account-link"
  }, sessionState.mySettings.text)), sessionState.myAccessTokens && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl(sessionState.myAccessTokens.href),
    className: "ui-meganav-account-link"
  }, sessionState.myAccessTokens.text, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "ui-version-tag"
  }, "preview")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("hr", {
    className: "ui-meganav-hr mb-16"
  }), sessionState.logOut && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "mb-16 px-16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_SignOutLink_component_jsx__WEBPACK_IMPORTED_MODULE_3__["default"], _extends({
    absUrl: absUrl
  }, sessionState.logOut), function (_ref2) {
    var text = _ref2.text,
        href = _ref2.href,
        onClick = _ref2.onClick;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
      onClick: onClick,
      href: absUrl(href),
      className: "ui-meganav-account-link"
    }, text);
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_MeganavSearch_component_jsx__WEBPACK_IMPORTED_MODULE_4__["default"], {
    absUrl: absUrl
  })), sessionState.account && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl(sessionState.account.links.dashboard.href),
    className: "ui-btn-secondary p-btn-small"
  }, "Dashboard")));
};

MeganavItemsSignedIn.propTypes = {
  sessionState: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
  paths: prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape({
    iconSprites: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
  }),
  theme: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
  absUrl: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MeganavItemsSignedIn);

/***/ }),

/***/ 97:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var _MeganavSearchPanel_component_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6569);





var MeganavSearch = function MeganavSearch(_ref) {
  var absUrl = _ref.absUrl;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    type: "button",
    "data-id": "meganav-control",
    "data-control": "search",
    className: "h-64 w-24 px-24 pr-48 py-20 group focus:outline-none",
    "aria-expanded": "false",
    "aria-controls": "panel-search",
    "aria-label": "Show Search Panel"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-gui-search",
    color: "text-cool-black",
    size: "1.5rem",
    additionalCSS: "group-hover:text-gui-hover group-focus:text-gui-focus"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "ui-meganav-panel invisible",
    id: "panel-search",
    "data-id": "meganav-panel"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_MeganavSearchPanel_component_jsx__WEBPACK_IMPORTED_MODULE_3__["default"], {
    absUrl: absUrl
  })));
};

MeganavSearch.propTypes = {
  absUrl: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MeganavSearch);

/***/ }),

/***/ 3833:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);


var MeganavSearchAutocomplete = function MeganavSearchAutocomplete() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "absolute w-full mt-8 z-10 hidden shadow-container rounded-lg bg-white border border-mid-grey",
    "data-id": "meganav-search-autocomplete-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ol", {
    className: "m-16",
    "data-id": "meganav-search-autocomplete-list"
  }));
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MeganavSearchAutocomplete);

/***/ }),

/***/ 6569:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var _MeganavSearchSuggestions_component_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8926);
/* harmony import */ var _MeganavSearchAutocomplete_component_jsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3833);






var MeganavSearchPanel = function MeganavSearchPanel(_ref) {
  var absUrl = _ref.absUrl;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("section", {
    className: "ui-meganav-content grid-cols-12"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-span-8"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "mb-32"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("form", {
    className: "flex items-start",
    action: absUrl("/search"),
    method: "get"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "relative w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Icon_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "icon-gui-search",
    color: "text-cool-black",
    size: "1.5rem",
    additionalCSS: "absolute top-12 left-16"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    type: "search",
    name: "q",
    className: "ui-input pl-48 h-48",
    placeholder: "Search",
    autoComplete: "off",
    "data-id": "meganav-search-input"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_MeganavSearchAutocomplete_component_jsx__WEBPACK_IMPORTED_MODULE_4__["default"], null)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    type: "submit",
    className: "ui-btn-secondary flex-shrink-0 ml-8 sm:ml-16 md:ml-24 xl:ml-32"
  }, "Search")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-span-12"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_MeganavSearchSuggestions_component_jsx__WEBPACK_IMPORTED_MODULE_3__["default"], {
    displaySupportLink: true,
    absUrl: absUrl
  })));
};

MeganavSearchPanel.propTypes = {
  absUrl: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MeganavSearchPanel);

/***/ }),

/***/ 8926:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _FeaturedLink_component_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5751);




var MeganavSearchSuggestions = function MeganavSearchSuggestions(_ref) {
  var absUrl = _ref.absUrl,
      displaySupportLink = _ref.displaySupportLink;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "ui-text-overline2 text-cool-black py-12"
  }, "Popular pages"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex justify-between items-center overflow-hidden"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "flex transition-transform"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    className: "py-12 pr-8 flex-shrink-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/docs/how-ably-works"),
    className: "ui-text-p2 hover:text-gui-hover active:text-gui-active focus:text-gui-focus"
  }, "How does Ably work?")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    className: "py-12 px-8 flex-shrink-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/docs/quick-start-guide"),
    className: "ui-text-p2 hover:text-gui-hover active:text-gui-active focus:text-gui-focus"
  }, "Quickstart guide")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    className: "py-12 px-8 flex-shrink-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/docs/core-features/pubsub"),
    className: "ui-text-p2 hover:text-gui-hover active:text-gui-active focus:text-gui-focus"
  }, "Publish/Subscribe Messaging")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    className: "py-12 pl-8 flex-shrink-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: absUrl("/platform"),
    className: "ui-text-p2 hover:text-gui-hover active:text-gui-active focus:text-gui-focus"
  }, "Platform"))), displaySupportLink ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_FeaturedLink_component_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], {
    url: absUrl("/support"),
    textSize: "text-p2"
  }, "Support") : null));
};

MeganavSearchSuggestions.propTypes = {
  absUrl: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  displaySupportLink: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MeganavSearchSuggestions);

/***/ }),

/***/ 3044:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ core_Notice_component)
});

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react"}
var external_commonjs_react_commonjs2_react_ = __webpack_require__(5225);
var external_commonjs_react_commonjs2_react_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_commonjs2_react_);
// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types"}
var external_commonjs_prop_types_commonjs2_prop_types_ = __webpack_require__(6073);
var external_commonjs_prop_types_commonjs2_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_prop_types_commonjs2_prop_types_);
// EXTERNAL MODULE: external {"commonjs":"js-cookie","commonjs2":"js-cookie"}
var external_commonjs_js_cookie_commonjs2_js_cookie_ = __webpack_require__(4360);
var external_commonjs_js_cookie_commonjs2_js_cookie_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_js_cookie_commonjs2_js_cookie_);
// EXTERNAL MODULE: external {"commonjs":"lodash.throttle","commonjs2":"lodash.throttle"}
var external_commonjs_lodash_throttle_commonjs2_lodash_throttle_ = __webpack_require__(7326);
var external_commonjs_lodash_throttle_commonjs2_lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_lodash_throttle_commonjs2_lodash_throttle_);
// EXTERNAL MODULE: ./src/core/dom-query.js
var dom_query = __webpack_require__(9581);
// EXTERNAL MODULE: ./src/core/Flash/component.jsx + 1 modules
var component = __webpack_require__(2139);
;// CONCATENATED MODULE: ./src/core/Notice/component.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var COOKIE_EXPIRY = 90;
var COLLAPSE_TRIGGER_DISTANCE = 5;
var SCROLL_LISTENER_THROTTLE = 100;
var RESIZE_LISTENER_THROTTLE = 100;

var isMdViewport = function isMdViewport() {
  return !window.matchMedia("(min-width: 65rem)").matches;
};

var adjustFlashMargin = function adjustFlashMargin(open) {
  // HACK ALERT
  // Add margin to flashes when opening the notice.
  // Flashes are react components and this notice needs to work as a view-component and react component.
  // We could do this with redux but then we potentially update state on every scroll event, which
  // even with debounce will deplate our frame budget.
  var flash = (0,dom_query/* queryId */.A)(component.FLASH_DATA_ID);

  if (flash) {
    flash.style.marginTop = open ? "4rem" : null;
  }
};

var hideOnMobile = function hideOnMobile(bannerContainer) {
  if (isMdViewport()) {
    bannerContainer.style.display = "none";
  } else {
    bannerContainer.style.display = null;
  }
};

var hideNotice = function hideNotice(bannerContainer) {
  bannerContainer.style.maxHeight = 0;
  bannerContainer.style.overflow = "hidden";
  adjustFlashMargin(false);
};

var showNotice = function showNotice(bannerContainer) {
  bannerContainer.style.maxHeight = null;
  bannerContainer.style.overflow = null;
  adjustFlashMargin(true);
};

var setupRememberClosed = function setupRememberClosed(cookieId, noticeId) {
  var cookie = external_commonjs_js_cookie_commonjs2_js_cookie_default().get(cookieId) || "";
  external_commonjs_js_cookie_commonjs2_js_cookie_default().set(cookieId, "".concat(cookie.replace("".concat(noticeId, ","), "") + noticeId, ","), {
    expires: COOKIE_EXPIRY
  });
};

var hasBeenClosedBefore = function hasBeenClosedBefore(cookieId, noticeId) {
  return (external_commonjs_js_cookie_commonjs2_js_cookie_default().get(cookieId) || "").includes(noticeId);
};

var setupNoticeCollapse = function setupNoticeCollapse(bannerContainer) {
  var scrollTop = window.scrollY;

  if (scrollTop > COLLAPSE_TRIGGER_DISTANCE) {
    hideNotice(bannerContainer);
  }

  var listener = external_commonjs_lodash_throttle_commonjs2_lodash_throttle_default()(function () {
    var scrollTop = window.scrollY;

    if (scrollTop > COLLAPSE_TRIGGER_DISTANCE) {
      hideNotice(bannerContainer);
    } else if (bannerContainer.style.overflow) {
      showNotice(bannerContainer);
    }
  }, SCROLL_LISTENER_THROTTLE);
  document.addEventListener("scroll", listener);
  return function () {
    return document.removeEventListener("scroll", listener);
  };
};

var setupCloseBtn = function setupCloseBtn(bannerContainer, cookieId, noticeId, collapseUnmountListeners) {
  var closeBtn = bannerContainer.querySelector("button");
  if (!closeBtn) return function () {};

  var listener = function listener() {
    if (cookieId && noticeId) setupRememberClosed(cookieId, noticeId);
    hideNotice(bannerContainer);
    collapseUnmountListeners();
  };

  closeBtn.addEventListener("click", listener);
  return function () {
    return document.removeEventListener("click", listener);
  };
};

var resizeHandler = function resizeHandler(bannerContainer) {
  var handler = external_commonjs_lodash_throttle_commonjs2_lodash_throttle_default()(function () {
    hideOnMobile(bannerContainer);
  }, RESIZE_LISTENER_THROTTLE);
  window.addEventListener("resize", handler);
  return function () {
    return window.removeEventListener("resize", handler);
  };
};

var Notice = function Notice(_ref) {
  var bannerContainer = _ref.bannerContainer,
      cookieId = _ref.cookieId,
      noticeId = _ref.noticeId,
      options = _ref.options;
  if (typeof window === "undefined") return function () {};

  if (!bannerContainer) {
    console.warn("A Notice component was initited but no notice container was found.");
    return function () {};
  }

  if (hasBeenClosedBefore(cookieId, noticeId)) return function () {};
  hideOnMobile(bannerContainer);
  showNotice(bannerContainer);

  var opts = _objectSpread({
    collapse: true
  }, options);

  var collapseUnmountListeners = opts.collapse ? setupNoticeCollapse(bannerContainer) : function () {};
  var closeBtnUnmountListeners = setupCloseBtn(bannerContainer, cookieId, noticeId, collapseUnmountListeners);
  var resizeUnmountListener = resizeHandler(bannerContainer);
  return function () {
    [closeBtnUnmountListeners, collapseUnmountListeners, resizeUnmountListener].forEach(function (unmount) {
      return unmount();
    });
  };
};

/* harmony default export */ const Notice_component = (Notice);
// EXTERNAL MODULE: ./src/core/Icon/component.jsx
var Icon_component = __webpack_require__(9008);
;// CONCATENATED MODULE: ./src/core/Notice/component.jsx


var contentWrapperClasses = "w-full pr-8 ui-text-p3 self-center";



var ContentWrapper = function ContentWrapper(_ref) {
  var buttonLink = _ref.buttonLink,
      children = _ref.children;
  return buttonLink ? /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: buttonLink,
    className: contentWrapperClasses
  }, children) : /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: contentWrapperClasses
  }, children);
};

ContentWrapper.propTypes = {
  buttonLink: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  children: (external_commonjs_prop_types_commonjs2_prop_types_default()).node
};

var component_Notice = function Notice(_ref2) {
  var buttonLink = _ref2.buttonLink,
      buttonLabel = _ref2.buttonLabel,
      bodyText = _ref2.bodyText,
      title = _ref2.title,
      config = _ref2.config,
      closeBtn = _ref2.closeBtn,
      _ref2$bgColor = _ref2.bgColor,
      bgColor = _ref2$bgColor === void 0 ? "bg-gradient-active-orange" : _ref2$bgColor,
      _ref2$textColor = _ref2.textColor,
      textColor = _ref2$textColor === void 0 ? "text-white" : _ref2$textColor;
  (0,external_commonjs_react_commonjs2_react_.useEffect)(function () {
    Notice_component({
      bannerContainer: document.querySelector('[data-id="ui-notice"]'),
      cookieId: config.cookieId,
      noticeId: config.noticeId,
      options: {
        collapse: config.collapse
      }
    });
  }, []);
  var wrapperClasses = ["ui-announcement", bgColor, textColor].join(" ");
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: wrapperClasses,
    "data-id": "ui-notice",
    style: {
      maxHeight: 0,
      overflow: "hidden"
    }
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-grid-px py-16 max-w-screen-xl mx-auto flex items-start"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(ContentWrapper, {
    buttonLink: buttonLink
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("strong", {
    className: "font-bold whitespace-nowrap pr-4"
  }, title), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("span", {
    className: "pr-4"
  }, bodyText), buttonLabel && /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("span", {
    className: "underline cursor-pointer whitespace-nowrap"
  }, buttonLabel)), closeBtn && /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("button", {
    type: "button",
    className: "ml-auto h-20 w-20 border-none bg-none self-baseline"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Icon_component["default"], {
    name: "icon-gui-close",
    size: "1.25rem",
    color: "text-cool-black"
  }))));
};

component_Notice.propTypes = {
  buttonLink: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  buttonLabel: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  bodyText: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  title: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  closeBtn: (external_commonjs_prop_types_commonjs2_prop_types_default()).bool,
  config: external_commonjs_prop_types_commonjs2_prop_types_default().shape({
    collapse: (external_commonjs_prop_types_commonjs2_prop_types_default()).bool,
    noticeId: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
    cookieId: (external_commonjs_prop_types_commonjs2_prop_types_default()).string
  }),
  bgColor: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  textColor: (external_commonjs_prop_types_commonjs2_prop_types_default()).string
};
/* harmony default export */ const core_Notice_component = (component_Notice);

/***/ }),

/***/ 1866:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);



var SignOutLink = function SignOutLink(_ref) {
  var token = _ref.token,
      href = _ref.href,
      text = _ref.text,
      children = _ref.children,
      absUrl = _ref.absUrl;
  var formRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var onClick = function onClick(e) {
    formRef.current.submit();
    e.preventDefault();
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("form", {
    ref: formRef,
    method: "post",
    action: absUrl(href),
    className: "hidden"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    name: "_method",
    value: "delete",
    type: "hidden"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    name: "authenticity_token",
    value: token,
    type: "hidden"
  })), children({
    href: href,
    text: text,
    onClick: onClick
  }));
};

SignOutLink.propTypes = {
  token: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  href: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  text: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  absUrl: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SignOutLink);

/***/ }),

/***/ 9581:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ queryId),
/* harmony export */   "n": () => (/* binding */ queryIdAll)
/* harmony export */ });
var queryId = function queryId(val) {
  var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return root.querySelector("[data-id=".concat(val, "]"));
};
var queryIdAll = function queryIdAll(val) {
  var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return root.querySelectorAll("[data-id=".concat(val, "]"));
};

/***/ }),

/***/ 3511:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cO": () => (/* binding */ getRemoteDataStore),
/* harmony export */   "kZ": () => (/* binding */ connectState)
/* harmony export */ });
/* unused harmony exports attachStoreToWindow, createRemoteDataStore */
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5293);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux__WEBPACK_IMPORTED_MODULE_0__);

var attachStoreToWindow = function attachStoreToWindow(store) {
  window.AblyUi = window.AblyUi || {};
  window.AblyUi.RemoteDataStore = store;
};
var getRemoteDataStore = function getRemoteDataStore() {
  if (!window.AblyUi.RemoteDataStore) {
    throw new Error("Remote store was called before one was created");
  }

  return window.AblyUi.RemoteDataStore;
};
var connectState = function connectState(selector, setState) {
  var store = getRemoteDataStore();
  var cachedOldState = selector(store);
  store.subscribe(function () {
    var newState = selector(store); // Do nothing, state is the same

    if (newState === cachedOldState) {
      return;
    }

    cachedOldState = newState;
    setState(newState);
  });
};
var createRemoteDataStore = function createRemoteDataStore(reducers) {
  return createStore(combineReducers(reducers));
};

/***/ }),

/***/ 3916:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3916__;

/***/ }),

/***/ 710:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__710__;

/***/ }),

/***/ 4360:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__4360__;

/***/ }),

/***/ 7326:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__7326__;

/***/ }),

/***/ 6073:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__6073__;

/***/ }),

/***/ 5225:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__5225__;

/***/ }),

/***/ 5293:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__5293__;

/***/ }),

/***/ 9042:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__9042__;

/***/ }),

/***/ 7061:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(8698)["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 8698:
/***/ ((module) => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 4687:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(7061)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 3166:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"n":{"white":{"backgroundColor":"bg-white","textColor":"text-cool-black","buttonBackgroundColor":"","buttonTextColor":"","mobileMenuColor":"text-cool-black","logoTextColor":"text-cool-black","barShadow":"shadow-subtle"},"black":{"backgroundColor":"bg-cool-black","textColor":"text-white","buttonBackgroundColor":"bg-white","buttonTextColor":"text-cool-black","mobileMenuColor":"text-white","logoTextColor":"text-white","barShadow":""},"transparentToWhite":{"backgroundColor":"bg-transparent","textColor":"text-white","buttonBackgroundColor":"bg-white","buttonTextColor":"text-cool-black","mobileMenuColor":"text-white","logoTextColor":"text-white","barShadow":""}},"h":[{"label":"Products","shortLabel":"Products","id":"products-panel","component":"MeganavContentProducts"},{"label":"Solutions","shortLabel":"Solutions","id":"use-cases-panel","component":"MeganavContentUseCases"},{"label":"Company","shortLabel":"Company","id":"company-panel","component":"MeganavContentCompany"},{"label":"Developers","shortLabel":"Developers","id":"developers-panel","component":"MeganavContentDevelopers"}]}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ component_Meganav)
});

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react"}
var external_commonjs_react_commonjs2_react_ = __webpack_require__(5225);
var external_commonjs_react_commonjs2_react_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_commonjs2_react_);
// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types"}
var external_commonjs_prop_types_commonjs2_prop_types_ = __webpack_require__(6073);
var external_commonjs_prop_types_commonjs2_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_prop_types_commonjs2_prop_types_);
// EXTERNAL MODULE: ./src/core/remote-data-store.js
var remote_data_store = __webpack_require__(3511);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(4687);
;// CONCATENATED MODULE: ./src/core/remote-session-data.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// Fetches current users session data
// Assumes an authenticated session, so will only work when used on ably.com/ably.io

var NOT_FOUND_ERROR_CODE = "not-found";

var fetchSessionData = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(store, sessionUrl) {
    var sessionLoaded, res, jsonResponse, payload;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sessionLoaded = function sessionLoaded() {
              var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return store.dispatch({
                type: "session/loaded",
                payload: payload
              });
            };

            _context.prev = 1;

            if (sessionUrl) {
              _context.next = 6;
              break;
            }

            console.log("Skipping fetching session, invalid sessionUrl: \"".concat(sessionUrl, "\""));
            sessionLoaded();
            return _context.abrupt("return");

          case 6:
            _context.next = 8;
            return fetch(sessionUrl, {
              cache: "no-cache"
            });

          case 8:
            res = _context.sent;
            jsonResponse = isJsonResponse(res.headers.get("content-type"));

            if (jsonResponse) {
              _context.next = 12;
              break;
            }

            throw new Error("Session endpoint is not serving json");

          case 12:
            _context.next = 14;
            return res.json();

          case 14:
            payload = _context.sent;

            if (payload.error === NOT_FOUND_ERROR_CODE) {
              sessionLoaded();
            } else {
              sessionLoaded(payload);
            }

            _context.next = 22;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](1);
            sessionLoaded();
            console.warn("Could not fetch session data due to error:", _context.t0);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 18]]);
  }));

  return function fetchSessionData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()));

var initialState = {
  data: null
};
var REDUCER_KEY = "session";

var reducerSessionData = _defineProperty({}, REDUCER_KEY, function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case "session/loaded":
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.payload
      });

    default:
      return state;
  }
});

var selectSessionData = function selectSessionData(store) {
  var _store$getState$REDUC;

  return (_store$getState$REDUC = store.getState()[REDUCER_KEY]) === null || _store$getState$REDUC === void 0 ? void 0 : _store$getState$REDUC.data;
};


// EXTERNAL MODULE: ./src/core/Logo/component.jsx
var component = __webpack_require__(3774);
// EXTERNAL MODULE: external {"commonjs":"lodash.throttle","commonjs2":"lodash.throttle"}
var external_commonjs_lodash_throttle_commonjs2_lodash_throttle_ = __webpack_require__(7326);
var external_commonjs_lodash_throttle_commonjs2_lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_lodash_throttle_commonjs2_lodash_throttle_);
// EXTERNAL MODULE: ./src/core/dom-query.js
var dom_query = __webpack_require__(9581);
;// CONCATENATED MODULE: ./src/core/MeganavControl/component.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



var MeganavControl = function MeganavControl() {
  var controls = Array.from((0,dom_query/* queryIdAll */.n)("meganav-control"));
  var panels = Array.from((0,dom_query/* queryIdAll */.n)("meganav-panel"));
  var mdBreakpoint = getComputedStyle(document.documentElement).getPropertyValue("--bp-md");

  var hoverEnabled = function hoverEnabled() {
    return window.matchMedia("(hover: hover) and (pointer: fine) and (min-width: ".concat(mdBreakpoint, ")")).matches;
  };

  var isSearchControl = function isSearchControl(node) {
    return node.dataset.control === "search";
  };

  var isSearchPanelOpen = function isSearchPanelOpen() {
    var searchPanel = document.querySelector('[data-id="meganav-panel"]#panel-search');
    if (!searchPanel) return;
    return !searchPanel.classList.contains("invisible");
  };

  var controlsHaveFocus = function controlsHaveFocus() {
    return controls.some(function (control) {
      return control === document.activeElement;
    });
  };

  var hover = function hover(control, panel, open) {
    if (hoverEnabled() && !controlsHaveFocus() && !isSearchPanelOpen()) {
      var _panel$classList;

      var classes = ["invisible", "visible"];

      (_panel$classList = panel.classList).replace.apply(_panel$classList, _toConsumableArray(open ? classes : classes.reverse()));

      control.setAttribute("aria-expanded", open);
      control.dataset.hover = open;
    }
  };

  var mouseenterHandler = function mouseenterHandler(control, panel) {
    return function () {
      return hover(control, panel, true);
    };
  };

  var mouseleaveHandler = function mouseleaveHandler(control, panel) {
    return function () {
      return hover(control, panel, false);
    };
  };

  var clickHandler = function clickHandler(control, panel) {
    return function () {
      controls.forEach(function (node) {
        return node !== control && node.setAttribute("aria-expanded", false);
      });
      panels.forEach(function (node) {
        return node !== panel && node.classList.replace("visible", "invisible");
      });
      var ariaExpanded = control.getAttribute("aria-expanded"); // Prevent closing of the panel if it was already opened by hovering

      var openedByHover = control.dataset.hover === "true";

      if (ariaExpanded === "true" && !openedByHover) {
        control.setAttribute("aria-expanded", false);
        panel.classList.replace("visible", "invisible");
      } else {
        control.setAttribute("aria-expanded", true);
        panel.classList.replace("invisible", "visible");
      }

      if (openedByHover) {
        control.dataset.hover = false;
      }

      if (isSearchControl(control)) {
        var searchInput = (0,dom_query/* queryId */.A)("meganav-search-input", panel);
        if (!searchInput) return;
        searchInput.focus();
      } else {
        control.focus();
      }
    };
  };

  return controls.map(function (control) {
    var item = control.parentNode;
    var panel = document.querySelector("#".concat(control.getAttribute("aria-controls")));
    var click = clickHandler(control, panel);
    control.addEventListener("click", click);
    var mouseenter, mouseleave;

    if (!isSearchControl(control)) {
      mouseenter = mouseenterHandler(control, panel);
      mouseleave = mouseleaveHandler(control, panel);
      item.addEventListener("mouseenter", mouseenter);
      item.addEventListener("mouseleave", mouseleave);
    }

    return [{
      teardown: function teardown() {
        if (mouseenter && mouseleave) {
          item.removeEventListener("mouseenter", mouseenter);
          item.removeEventListener("mouseleave", mouseleave);
        }

        control.removeEventListener("click", click);
      },
      clear: function clear() {
        control.setAttribute("aria-expanded", false);
        panel.classList.replace("visible", "invisible");
      }
    }];
  }).flat();
};

/* harmony default export */ const MeganavControl_component = (MeganavControl);
// EXTERNAL MODULE: external {"commonjs":"scroll-lock","commonjs2":"scroll-lock"}
var external_commonjs_scroll_lock_commonjs2_scroll_lock_ = __webpack_require__(9042);
var external_commonjs_scroll_lock_commonjs2_scroll_lock_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_scroll_lock_commonjs2_scroll_lock_);
;// CONCATENATED MODULE: ./src/core/MeganavControlMobileDropdown/component.js



var MeganavControlMobileDropdown = function MeganavControlMobileDropdown(_ref) {
  var clearPanels = _ref.clearPanels;
  var control = (0,dom_query/* queryId */.A)("meganav-control-mobile-dropdown");
  var dropdown = (0,dom_query/* queryId */.A)("meganav-mobile-dropdown");
  var menuIcon = (0,dom_query/* queryId */.A)("meganav-control-mobile-dropdown-menu");
  var closeIcon = (0,dom_query/* queryId */.A)("meganav-control-mobile-dropdown-close");

  var clickHandler = function clickHandler() {
    var ariaExpanded = control.getAttribute("aria-expanded");

    if (ariaExpanded === "false") {
      dropdown.classList.replace("invisible", "visible");
      control.setAttribute("aria-expanded", true);
      external_commonjs_scroll_lock_commonjs2_scroll_lock_default().disablePageScroll();
    } else {
      dropdown.classList.replace("visible", "invisible");
      control.setAttribute("aria-expanded", false);
      external_commonjs_scroll_lock_commonjs2_scroll_lock_default().enablePageScroll();
      clearPanels();
    }

    menuIcon.classList.toggle("hidden");
    closeIcon.classList.toggle("hidden");
  };

  control.addEventListener("click", clickHandler);
  return {
    teardown: function teardown() {
      control.removeEventListener("click", clickHandler);
      external_commonjs_scroll_lock_commonjs2_scroll_lock_default().enablePageScroll();
    },
    clear: function clear() {
      dropdown.classList.replace("visible", "invisible");
      control.setAttribute("aria-expanded", false);
      menuIcon.classList.remove("hidden");
      closeIcon.classList.add("hidden");
      external_commonjs_scroll_lock_commonjs2_scroll_lock_default().enablePageScroll();
    }
  };
};

/* harmony default export */ const MeganavControlMobileDropdown_component = (MeganavControlMobileDropdown);
;// CONCATENATED MODULE: ./src/core/css.js
var remsToPixelValue = function remsToPixelValue(remString) {
  return parseFloat(remString) * parseFloat(getComputedStyle(document.documentElement).fontSize);
};
;// CONCATENATED MODULE: ./src/core/MeganavControlMobilePanelOpen/component.js


/* harmony default export */ const MeganavControlMobilePanelOpen_component = (function () {
  var closeControls = Array.from((0,dom_query/* queryIdAll */.n)("meganav-control-mobile-panel-close"));
  var openControls = Array.from((0,dom_query/* queryIdAll */.n)("meganav-control-mobile-panel-open"));
  var dropdown = (0,dom_query/* queryId */.A)("meganav-mobile-dropdown"); // Height is defined in rem's so to get the pixel value we need to find the fontSize on root

  var meganavHeight = remsToPixelValue(getComputedStyle(document.documentElement).getPropertyValue("--ui-meganav-height"));

  var clickHandler = function clickHandler(btn, closeBtn, panel) {
    return function () {
      btn.setAttribute("aria-expanded", true);
      closeBtn.setAttribute("aria-expanded", true);
      panel.classList.replace("hidden", "block"); // On devices where we don't have enough space for the panel, set it's height to
      // the height of the viewport (minus the meganav height) - this will trigger a scroll.
      // Otherwise just set it to the panel height. This handles the case where the ratio of vertical
      // space to horizontal is especially high (think tablets, but not only).

      panel.style.height = "".concat(window.innerHeight - meganavHeight > panel.offsetHeight ? panel.offsetHeight : window.innerHeight - meganavHeight, "px");
    };
  };

  return openControls.map(function (btn) {
    var closeBtn = closeControls.find(function (node) {
      return node.getAttribute("aria-controls") === btn.getAttribute("aria-controls");
    });
    var panel = document.querySelector("#".concat(btn.getAttribute("aria-controls")));
    var handler = clickHandler(btn, closeBtn, panel);
    btn.addEventListener("click", handler);
    return {
      teardown: function teardown() {
        return btn.removeEventListener("click", handler);
      },
      clear: function clear() {
        panel.classList.replace("block", "hidden");
        dropdown.classList.remove("ui-meganav-mobile-dropdown-expand");
        btn.setAttribute("aria-expanded", false);
        panel.style.height = null;
      }
    };
  });
});
;// CONCATENATED MODULE: ./src/core/MeganavControlMobilePanelClose/component.js

/* harmony default export */ const MeganavControlMobilePanelClose_component = (function () {
  var closeControls = Array.from((0,dom_query/* queryIdAll */.n)("meganav-control-mobile-panel-close"));
  var openControls = Array.from((0,dom_query/* queryIdAll */.n)("meganav-control-mobile-panel-open"));

  var clickHandler = function clickHandler(btn, openBtn, panel) {
    return function () {
      btn.setAttribute("aria-expanded", false);
      openBtn.setAttribute("aria-expanded", false);
      panel.classList.replace("block", "hidden");
      panel.style.height = null;
    };
  };

  return closeControls.map(function (btn) {
    var openBtn = openControls.find(function (open) {
      return open.getAttribute("aria-controls") === btn.getAttribute("aria-controls");
    });
    var panel = document.querySelector("#".concat(btn.getAttribute("aria-controls")));
    var handler = clickHandler(btn, openBtn, panel);
    btn.addEventListener("click", handler);
    return {
      teardown: function teardown() {
        return btn.removeEventListener("click", handler);
      },
      clear: function clear() {
        return btn.setAttribute("aria-expanded", false);
      }
    };
  });
});
// EXTERNAL MODULE: external {"commonjs":"addsearch-js-client","commonjs2":"addsearch-js-client"}
var external_commonjs_addsearch_js_client_commonjs2_addsearch_js_client_ = __webpack_require__(3916);
var external_commonjs_addsearch_js_client_commonjs2_addsearch_js_client_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_addsearch_js_client_commonjs2_addsearch_js_client_);
;// CONCATENATED MODULE: ./src/core/MeganavSearchAutocomplete/component.js



var init = function init(_ref) {
  var input = _ref.input,
      container = _ref.container,
      listContainer = _ref.listContainer,
      clear = _ref.clear,
      client = _ref.client;
  client.setAnalyticsTag("Meganav autocomplete");
  client.setThrottleTime(400);

  var clearResults = function clearResults() {
    container.classList.add("hidden");
    listContainer.innerHTML = "";
  };

  var toggleClearBtn = function toggleClearBtn(query) {
    if ((query || "").length > 0 && clear) {
      clear.classList.remove("invisible");
    } else if (clear) {
      clear.classList.add("invisible");
    }
  };

  var markQueryInSuggestion = function markQueryInSuggestion(suggestionValue, query) {
    return suggestionValue.replace(query.toLowerCase(), "<span class=\"font-light\">".concat(query, "</span>"));
  };

  var navigateToUrl = function navigateToUrl(q) {
    return window.location = "/search?q=".concat(q);
  };

  var focusNext = function focusNext(index) {
    var nextSuggestion = listContainer.querySelector("[data-suggestion-index=\"".concat(index + 1, "\"]"));
    if (!nextSuggestion) return;
    nextSuggestion.focus();
  };

  var focusPrevious = function focusPrevious(index) {
    var previousIndex = index - 1;
    var previousSuggestion = listContainer.querySelector("[data-suggestion-index=\"".concat(previousIndex, "\"]"));
    if (!previousSuggestion) return;
    previousSuggestion.focus();
  };

  var renderResults = function renderResults(query) {
    return function () {
      var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      toggleClearBtn(query); // Prevent invalid access error when key is invalid

      if (!Array.isArray(results.suggestions)) {
        clearResults();
        return;
      } // Prevent key error from invalid key


      if (results.suggestions.length === 0) {
        clearResults();
        return;
      }

      var items = results.suggestions.map(function (suggestion, index) {
        var li = document.createElement("li");
        var button = document.createElement("button");
        button.type = "button";
        button.classList.add("ui-text-menu2", "font-medium", "p-8", "w-full", "text-left", "rounded", "hover:text-gui-hover", "focus:outline-gui-focus", "hover:bg-light-grey");
        button.innerHTML = markQueryInSuggestion(suggestion.value, query);
        button.dataset.suggestionIndex = index;
        button.addEventListener("click", function () {
          navigateToUrl(suggestion.value);
        });
        button.addEventListener("keydown", function (e) {
          var key = e.key;

          if (key === "ArrowDown") {
            focusNext(index);
          } else if (key === "ArrowUp" && index - 1 < 0) {
            input.focus();
          } else if (key === "ArrowUp" && index - 1 >= 0) {
            focusPrevious(index);
          } else if (key === "Enter" || key === "Space") {
            navigateToUrl(suggestion.value);
          }
        });
        li.appendChild(button);
        return li;
      });
      listContainer.innerHTML = "";
      items.forEach(function (item) {
        return listContainer.appendChild(item);
      });
      container.classList.remove("hidden");
    };
  };

  var keyupHandler = function keyupHandler(e) {
    var query = e.target.value;
    var key = e.key;

    if (key === "ArrowDown") {
      focusNext(0);
      return;
    }

    if (!query) {
      clearResults();
    } else {
      client.suggestions(query, renderResults(query));
    }
  };

  var clearHandler;

  if (clear) {
    clearHandler = function clearHandler() {
      input.value = "";
      clear.classList.add("invisible");
      clearResults();
    };

    clear.addEventListener("click", clearHandler);
  }

  input.addEventListener("keyup", keyupHandler);
  return {
    teardown: function teardown() {
      input.removeEventListener("keyup", keyupHandler);
      if (clear) clear.removeEventListener("click", clearHandler);
    },
    clear: function clear() {
      input.value = "";
      clearResults();
    }
  };
};

/* harmony default export */ const MeganavSearchAutocomplete_component = (function (apiKey) {
  if (!apiKey) {
    console.log("No AddSearch API key provided, skipping search suggestions.");
    return [];
  }

  var client = new (external_commonjs_addsearch_js_client_commonjs2_addsearch_js_client_default())(apiKey);
  return [(0,dom_query/* queryId */.A)("meganav-search-input"), (0,dom_query/* queryId */.A)("meganav-mobile-search-input")].filter(function (i) {
    return i;
  }).map(function (input) {
    var parent = input.parentNode;
    var container = (0,dom_query/* queryId */.A)("meganav-search-autocomplete-container", parent);
    var listContainer = (0,dom_query/* queryId */.A)("meganav-search-autocomplete-list", parent);
    var clear = (0,dom_query/* queryId */.A)("meganav-search-input-clear", parent);
    return init({
      input: input,
      container: container,
      listContainer: listContainer,
      client: client,
      clear: clear
    });
  });
});
;// CONCATENATED MODULE: ./src/core/MeganavSearchSuggestions/component.js

var DRAG_BUFFER = 5;

var getTranslateX = function getTranslateX(node) {
  return new DOMMatrix(window.getComputedStyle(node).transform).e;
};

var updateTranslateX = function updateTranslateX(node, value) {
  return node.style.transform = "translateX(".concat(value, "px)");
};

var dragLeftBoundary = function dragLeftBoundary(translateX, threshold) {
  return translateX >= threshold;
};

var dragRightBoundary = function dragRightBoundary(translateX, itemsWidth, windowWidth, threshold) {
  return Math.abs(translateX - windowWidth + threshold) > itemsWidth;
};

var getDistance = function getDistance(e, touchStartX) {
  var _e$changedTouches$;

  return ((_e$changedTouches$ = e.changedTouches[0]) === null || _e$changedTouches$ === void 0 ? void 0 : _e$changedTouches$.clientX) - touchStartX;
};

var withinBuffer = function withinBuffer(distance) {
  return Math.abs(distance) < DRAG_BUFFER;
};

var getItemsTotalWidth = function getItemsTotalWidth(nodes) {
  return nodes.map(function (item) {
    return item.getBoundingClientRect().width;
  }).reduce(function (acc, val) {
    return acc + val;
  }, 0);
};

var MeganavSearchSuggestions = function MeganavSearchSuggestions() {
  var suggestionsToggle = (0,dom_query/* queryId */.A)("meganav-mobile-search-input");
  var suggestions = (0,dom_query/* queryId */.A)("meganav-mobile-search-suggestions");
  var list = suggestions.querySelector("ul");
  var listItems = Array.from(list.querySelectorAll("li"));

  var dragLeft = function dragLeft(distance, threshold) {
    var currentTranslateX = getTranslateX(list);
    var translateX = Math.round(currentTranslateX + distance);
    if (dragLeftBoundary(translateX, threshold)) return;
    updateTranslateX(list, translateX);
  };

  var dragLeftEnd = function dragLeftEnd(distance, threshold) {
    var currentTranslateX = getTranslateX(list);
    var translateX = Math.round(currentTranslateX + distance);

    if (dragLeftBoundary(translateX, threshold)) {
      translateX = 0;
    }

    updateTranslateX(list, translateX);
  };

  var dragRight = function dragRight(distance, threshold) {
    var listWidth = list.getBoundingClientRect().width;
    var currentTranslateX = getTranslateX(list);
    var translateX = Math.round(currentTranslateX + distance);
    var itemsTotalWidth = getItemsTotalWidth(listItems);

    if (dragRightBoundary(translateX, itemsTotalWidth, listWidth, threshold)) {
      return;
    }

    updateTranslateX(list, translateX);
  };

  var dragRightEnd = function dragRightEnd(distance, threshold) {
    var listWidth = list.getBoundingClientRect().width;
    var currentTranslateX = getTranslateX(list);
    var itemsTotalWidth = getItemsTotalWidth(listItems);
    var translateX = Math.round(currentTranslateX + distance);

    if (dragRightBoundary(translateX, itemsTotalWidth, listWidth, threshold)) {
      translateX = -(itemsTotalWidth - listWidth + threshold);
    }

    updateTranslateX(list, translateX);
  };

  var touchStartX;

  var touchstartHandler = function touchstartHandler(e) {
    var _e$touches$;

    touchStartX = (_e$touches$ = e.touches[0]) === null || _e$touches$ === void 0 ? void 0 : _e$touches$.clientX;
  };

  var touchmoveHandler = function touchmoveHandler(e) {
    var distance = getDistance(e, touchStartX);
    if (withinBuffer(distance)) return;
    distance > 0 ? dragLeft(distance, 24) : dragRight(distance, 96);
  };

  var touchendHandler = function touchendHandler(e) {
    var distance = getDistance(e, touchStartX);
    if (withinBuffer(distance)) return;
    distance > 0 ? dragLeftEnd(distance, 24) : dragRightEnd(distance, 48);
  };

  var focusSuggestionsHandler = function focusSuggestionsHandler() {
    suggestions.classList.add("max-h-96");
  };

  var blurSuggestionsHandler = function blurSuggestionsHandler(e) {
    if (e.relatedTarget === suggestions.querySelectorAll("a")[0]) {
      return;
    }

    suggestions.classList.remove("max-h-96");
  };

  var wheelHandler = function wheelHandler(e) {
    var distance = e.deltaY * 4;
    if (withinBuffer(distance)) return;
    distance > 0 ? dragLeftEnd(distance, 24) : dragRightEnd(distance, 48);
  };

  suggestionsToggle.addEventListener("focus", focusSuggestionsHandler);
  suggestionsToggle.addEventListener("blur", blurSuggestionsHandler);
  suggestions.addEventListener("touchstart", touchstartHandler);
  suggestions.addEventListener("touchmove", touchmoveHandler);
  suggestions.addEventListener("touchend", touchendHandler);
  suggestions.addEventListener("wheel", wheelHandler);
  return {
    teardown: function teardown() {
      suggestionsToggle.removeEventListener("focus", focusSuggestionsHandler);
      suggestionsToggle.removeEventListener("blur", blurSuggestionsHandler);
      suggestions.removeEventListener("touchstart", touchstartHandler);
      suggestions.removeEventListener("touchmove", touchmoveHandler);
      suggestions.removeEventListener("touchend", touchendHandler);
    },
    clear: function clear() {
      suggestions.classList.remove("max-h-96");
      list.style.transform = "translateX(0px)";
    }
  };
};

/* harmony default export */ const MeganavSearchSuggestions_component = (MeganavSearchSuggestions);
;// CONCATENATED MODULE: ./src/core/Meganav/component.js
function component_toConsumableArray(arr) { return component_arrayWithoutHoles(arr) || component_iterableToArray(arr) || component_unsupportedIterableToArray(arr) || component_nonIterableSpread(); }

function component_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function component_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return component_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return component_arrayLikeToArray(o, minLen); }

function component_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function component_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return component_arrayLikeToArray(arr); }

function component_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


 // Glossary:
// item - is the element which contains both the control and the panel - these are adjacent
// control - interactive element that controls showing and hiding of dropdown or panel
// panel - container for meganav content
// dropdown - container for top level items on mobile
// clear - return to initial state
// teardown - remove all event listeners (for example when removing nodes)







 // Close menu when user clicks outside of viewport

var windowOnBlur = function windowOnBlur(closeAll) {
  window.onblur = function () {
    return closeAll();
  };

  return {
    teardown: function teardown() {
      return window.onblur = null;
    }
  };
}; // Close menu when click/tap outside of nav


var documentClick = function documentClick(closeAll) {
  var meganav = (0,dom_query/* queryId */.A)("meganav");

  var clickHandler = function clickHandler(e) {
    if (meganav.contains(e.target)) return;
    closeAll();
  };

  document.addEventListener("click", clickHandler);
  return {
    teardown: function teardown() {
      return document.removeEventListener("click", clickHandler);
    }
  };
}; // Invert from transparent to white


var documentScroll = function documentScroll(themeName) {
  if (themeName !== "transparentToWhite") return {
    teardown: function teardown() {}
  };
  var meganav = (0,dom_query/* queryId */.A)("meganav");
  var navItems = (0,dom_query/* queryIdAll */.n)("meganav-link");
  var controlMobileDropdownMenu = (0,dom_query/* queryId */.A)("meganav-control-mobile-dropdown-menu");
  var controlMobileDropdownClose = (0,dom_query/* queryId */.A)("meganav-control-mobile-dropdown-close");
  var controls = (0,dom_query/* queryIdAll */.n)("meganav-control");
  var signUpBtn = (0,dom_query/* queryId */.A)("meganav-sign-up-btn");
  var invertTextCollection = [].concat(component_toConsumableArray(Array.from(controls)), component_toConsumableArray(Array.from(navItems)), [(0,dom_query/* queryId */.A)("meganav-logo")]);

  var invertMobleDropdownColor = function invertMobleDropdownColor(invert) {
    var whiteToBlack = ["ui-icon-white", "ui-icon-cool-black"];
    var blackToWhite = [].concat(whiteToBlack).reverse();

    if (invert) {
      var _controlMobileDropdow, _controlMobileDropdow2;

      controlMobileDropdownMenu === null || controlMobileDropdownMenu === void 0 ? void 0 : (_controlMobileDropdow = controlMobileDropdownMenu.classList).replace.apply(_controlMobileDropdow, whiteToBlack);
      controlMobileDropdownClose === null || controlMobileDropdownClose === void 0 ? void 0 : (_controlMobileDropdow2 = controlMobileDropdownClose.classList).replace.apply(_controlMobileDropdow2, whiteToBlack);
    } else {
      var _controlMobileDropdow3, _controlMobileDropdow4;

      controlMobileDropdownMenu === null || controlMobileDropdownMenu === void 0 ? void 0 : (_controlMobileDropdow3 = controlMobileDropdownMenu.classList).replace.apply(_controlMobileDropdow3, component_toConsumableArray(blackToWhite));
      controlMobileDropdownClose === null || controlMobileDropdownClose === void 0 ? void 0 : (_controlMobileDropdow4 = controlMobileDropdownClose.classList).replace.apply(_controlMobileDropdow4, component_toConsumableArray(blackToWhite));
    }
  };

  var inverSignupBtnColors = function inverSignupBtnColors(invert) {
    if (invert) {
      signUpBtn === null || signUpBtn === void 0 ? void 0 : signUpBtn.classList.replace("bg-white", "bg-cool-black");
      signUpBtn === null || signUpBtn === void 0 ? void 0 : signUpBtn.classList.replace("text-cool-black", "text-white");
    } else {
      signUpBtn === null || signUpBtn === void 0 ? void 0 : signUpBtn.classList.replace("bg-cool-black", "bg-white");
      signUpBtn === null || signUpBtn === void 0 ? void 0 : signUpBtn.classList.replace("text-white", "text-cool-black");
    }
  };

  var scrollHandler = external_commonjs_lodash_throttle_commonjs2_lodash_throttle_default()(function () {
    if (window.scrollY > 5) {
      meganav.classList.replace("bg-transparent", "bg-white");
      inverSignupBtnColors(true);
      invertMobleDropdownColor(true);
      invertTextCollection.forEach(function (n) {
        return n.classList.replace("text-white", "text-cool-black");
      });
    } else {
      meganav.classList.replace("bg-white", "bg-transparent");
      inverSignupBtnColors(false);
      invertMobleDropdownColor(false);
      invertTextCollection.forEach(function (n) {
        return n.classList.replace("text-cool-black", "text-white");
      });
    }
  }, 150);
  document.addEventListener("scroll", scrollHandler);
  return {
    teardown: function teardown() {
      return document.removeEventListener("scroll", scrollHandler);
    }
  };
};

function Meganav() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    themeName: null
  },
      themeName = _ref.themeName,
      addSearchApiKey = _ref.addSearchApiKey;

  var controls = MeganavControl_component();
  var panelOpenControls = MeganavControlMobilePanelOpen_component();
  var panelCloseControls = MeganavControlMobilePanelClose_component();
  var search = MeganavSearchAutocomplete_component(addSearchApiKey);
  var searchSuggestions = MeganavSearchSuggestions_component();
  var mobileDropdownControl = MeganavControlMobileDropdown_component({
    clearPanels: function clearPanels() {
      return [].concat(component_toConsumableArray(panelOpenControls), component_toConsumableArray(panelCloseControls)).forEach(function (i) {
        return i.clear();
      });
    }
  });

  var closeAll = function closeAll() {
    return [mobileDropdownControl, searchSuggestions].concat(component_toConsumableArray(panelOpenControls), component_toConsumableArray(panelCloseControls), component_toConsumableArray(controls), component_toConsumableArray(search)).forEach(function (i) {
      return i.clear();
    });
  };

  var teardowns = [documentScroll(themeName), documentClick(closeAll), windowOnBlur(closeAll), mobileDropdownControl, searchSuggestions].concat(component_toConsumableArray(controls), component_toConsumableArray(panelOpenControls), component_toConsumableArray(panelCloseControls), component_toConsumableArray(search)).map(function (i) {
    return i.teardown;
  });
  return function () {
    return teardowns.forEach(function (teardown) {
      return teardown();
    });
  };
}
// EXTERNAL MODULE: ./src/core/MeganavItemsDesktop/component.jsx
var MeganavItemsDesktop_component = __webpack_require__(3893);
// EXTERNAL MODULE: ./src/core/MeganavItemsSignedIn/component.jsx
var MeganavItemsSignedIn_component = __webpack_require__(9508);
// EXTERNAL MODULE: ./src/core/MeganavItemsMobile/component.jsx
var MeganavItemsMobile_component = __webpack_require__(2016);
// EXTERNAL MODULE: ./src/core/Notice/component.jsx + 1 modules
var Notice_component = __webpack_require__(3044);
// EXTERNAL MODULE: ./src/core/Meganav/component.json
var Meganav_component = __webpack_require__(3166);
;// CONCATENATED MODULE: ./src/core/url-base.js
var DEFAULT_URL_BASE = "";

var absUrl = function absUrl(path) {
  var urlBase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_URL_BASE;
  return "".concat(urlBase).concat(path);
};

/* harmony default export */ const url_base = (absUrl);
// EXTERNAL MODULE: ./src/core/MeganavContentProducts/component.jsx
var MeganavContentProducts_component = __webpack_require__(8254);
// EXTERNAL MODULE: ./src/core/MeganavContentUseCases/component.jsx
var MeganavContentUseCases_component = __webpack_require__(1118);
// EXTERNAL MODULE: ./src/core/MeganavContentCompany/component.jsx + 1 modules
var MeganavContentCompany_component = __webpack_require__(1505);
// EXTERNAL MODULE: ./src/core/MeganavContentDevelopers/component.jsx
var MeganavContentDevelopers_component = __webpack_require__(2619);
// EXTERNAL MODULE: ./src/core/MeganavSearch/component.jsx
var MeganavSearch_component = __webpack_require__(97);
;// CONCATENATED MODULE: ./src/core/Meganav/component.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || Meganav_component_unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function Meganav_component_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return Meganav_component_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Meganav_component_arrayLikeToArray(o, minLen); }

function Meganav_component_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



















var SignIn = function SignIn(_ref) {
  var sessionState = _ref.sessionState,
      theme = _ref.theme,
      loginLink = _ref.loginLink,
      absUrl = _ref.absUrl;
  return sessionState.signedIn ? /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(MeganavItemsSignedIn_component["default"], {
    absUrl: absUrl,
    sessionState: sessionState,
    theme: theme
  }) : /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("ul", {
    className: "hidden md:flex items-center"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "ui-meganav-item"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/contact"),
    className: "ui-meganav-link ".concat(theme.textColor),
    "data-id": "meganav-link"
  }, "Contact us")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "ui-meganav-item"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl(loginLink),
    className: "ui-meganav-link mr-0 ".concat(theme.textColor),
    "data-id": "meganav-link"
  }, "Login")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "ui-meganav-item"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(MeganavSearch_component["default"], {
    absUrl: absUrl
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "ui-meganav-item"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/sign-up"),
    "data-id": "meganav-sign-up-btn",
    className: "ui-btn p-btn-small ".concat(theme.buttonBackgroundColor, " ").concat(theme.buttonTextColor)
  }, "Sign up free")));
};

SignIn.propTypes = {
  sessionState: (external_commonjs_prop_types_commonjs2_prop_types_default()).object,
  paths: (external_commonjs_prop_types_commonjs2_prop_types_default()).object,
  theme: (external_commonjs_prop_types_commonjs2_prop_types_default()).object,
  loginLink: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  absUrl: (external_commonjs_prop_types_commonjs2_prop_types_default()).func
};

var SignInPlaceholder = function SignInPlaceholder() {
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", null);
};

var panels = {
  MeganavContentProducts: MeganavContentProducts_component["default"],
  MeganavContentUseCases: MeganavContentUseCases_component["default"],
  MeganavContentCompany: MeganavContentCompany_component["default"],
  MeganavContentDevelopers: MeganavContentDevelopers_component["default"]
};
function component_Meganav(_ref2) {
  var paths = _ref2.paths,
      _ref2$themeName = _ref2.themeName,
      themeName = _ref2$themeName === void 0 ? "white" : _ref2$themeName,
      notice = _ref2.notice,
      _ref2$loginLink = _ref2.loginLink,
      loginLink = _ref2$loginLink === void 0 ? "/login" : _ref2$loginLink,
      urlBase = _ref2.urlBase,
      addSearchApiKey = _ref2.addSearchApiKey;

  var _useState = (0,external_commonjs_react_commonjs2_react_.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      sessionState = _useState2[0],
      setSessionState = _useState2[1];

  (0,external_commonjs_react_commonjs2_react_.useEffect)(function () {
    // Note if state is never updated, sessionState stays null and never removes the placeholder.
    // This makes SSR consistent (ie. we always show the placeholder)
    (0,remote_data_store/* connectState */.kZ)(selectSessionData, setSessionState);
  }, []);
  (0,external_commonjs_react_commonjs2_react_.useEffect)(function () {
    var teardown = Meganav({
      themeName: themeName,
      addSearchApiKey: addSearchApiKey
    });
    return function () {
      return teardown();
    };
  }, [sessionState]);
  var theme = Meganav_component/* themes */.n[themeName];

  var absUrl = function absUrl(path) {
    return url_base(path, urlBase);
  };

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("nav", {
    className: "ui-meganav-wrapper ".concat(theme.backgroundColor, " ").concat(theme.barShadow),
    "data-id": "meganav",
    "aria-label": "Main"
  }, notice && /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Notice_component["default"], _extends({}, notice.props, {
    config: notice.config
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-meganav ui-grid-px"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "mr-24"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    dataId: "meganav-logo",
    href: urlBase,
    logoUrl: paths.logo
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(MeganavItemsDesktop_component["default"], {
    panels: panels,
    paths: paths,
    theme: theme,
    absUrl: absUrl
  }), sessionState ? /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(SignIn, {
    sessionState: sessionState,
    theme: theme,
    loginLink: loginLink,
    absUrl: absUrl
  }) : /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(SignInPlaceholder, null), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(MeganavItemsMobile_component["default"], {
    panels: panels,
    sessionState: sessionState || {},
    paths: paths,
    theme: theme,
    loginLink: loginLink,
    absUrl: absUrl
  })));
}
component_Meganav.propTypes = {
  paths: (external_commonjs_prop_types_commonjs2_prop_types_default()).object,
  themeName: external_commonjs_prop_types_commonjs2_prop_types_default().oneOf(["white", "black", "transparentToWhite"]),
  notice: external_commonjs_prop_types_commonjs2_prop_types_default().shape({
    props: external_commonjs_prop_types_commonjs2_prop_types_default().shape({
      title: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
      bodyText: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
      buttonLink: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
      buttonLabel: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
      closeBtn: (external_commonjs_prop_types_commonjs2_prop_types_default()).bool
    }),
    config: external_commonjs_prop_types_commonjs2_prop_types_default().shape({
      cookieId: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
      noticeId: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
      collapse: (external_commonjs_prop_types_commonjs2_prop_types_default()).bool
    })
  }),
  loginLink: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  urlBase: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  addSearchApiKey: (external_commonjs_prop_types_commonjs2_prop_types_default()).string
};
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});